export default {"src":"/_next/static/media/home-sun.76db52cc.svg","height":102,"width":106,"blurWidth":0,"blurHeight":0};